import React from 'react';
import { Typography, Tabs, Tab, Box, tabsClasses } from '@mui/material';
import { urlFor } from '../client';
import { Link } from 'react-router-dom';

const Cores = ({ core, jogos, totalJogos }) => {
  if (!jogos || jogos.length === 0) {
    return (
      <Typography variant="subtitle1">
        Nenhum jogo encontrado para o core: {core}
      </Typography>
    );
  }

  return (
    <Box sx={{ mt: 2, ':first-of-type': { mt: 0 }, ':last-child': { mb: 0 } }}>
      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            mb: 1
          }}
        >
          <Typography
            variant="h6"
            component={Link}
            to={`/${core}`}
            sx={{
              lineHeight: 1,
              textDecoration: 'none',
              color: 'inherit'
            }}
          >
            {core === 'atari2600' && 'Atari 2600'}
            {core === 'gb' && 'Game Boy'}
            {core === 'gbc' && 'Game Boy Color'}
            {core === 'n64' && 'Nintendo 64'}
            {core === 'nes' && 'Nintendo'}
            {core === 'segaMS' && 'Sega Master System'}
            {core === 'snes' && 'Super Nintendo'}
            {core === 'psx' && 'Playstation'}
          </Typography>
          <Typography
            component={Link}
            to={`/${core}`}
            color='textSecondary'
            sx={{
              pl: .5,
              lineHeight: 1,
              textDecoration: 'none',
              color: 'inherit'
            }}
          >
            {totalJogos !== undefined ? `(${totalJogos} jogos)` : `(${jogos.length} jogos)`}
          </Typography>
        </Box>
      </Box>
      <Tabs
        value={false}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label={`jogos do core ${core}`}
        sx={{
          '& .MuiTabs-scrollableX': {
            overflow: 'auto !important',
          },
          [`& .${tabsClasses.scrollButtons}`]: {
            '&.Mui-disabled': { opacity: 0.25 },
          },
        }}
      >
        {jogos.map((jogo) => (
          <Tab
            wrapped
            key={jogo.name}
            component={Link}
            to={`/${jogo.core}/${jogo.slug?.current}`}
            aria-label={jogo.name}
            sx={{
              ':hover': {
                bgcolor: 'rgba(255, 255, 255, 0.08)',
              }
            }}
            icon={
              jogo.box?.asset?.url && (
                <Box
                  component="img"
                  src={urlFor(jogo.box).width(256).url()}
                  alt={jogo.name}
                  sx={{
                    height: 128,
                    objectFit: 'cover'
                  }}
                />
              )
            }
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default Cores;